// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3g5Nx","content":"LayoutSettings_content__2_zTS"};